import { render, staticRenderFns } from "./departments.vue?vue&type=template&id=6874c6f1&scoped=true"
import script from "./departments.vue?vue&type=script&lang=js"
export * from "./departments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6874c6f1",
  null
  
)

export default component.exports